module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-OV-5200.134a024f.png";